import ajax from '@utils/ajax';

const rootUrl = '/capsiminbox/admin/api/tags';

export const createTag = async (payload) => await ajax('POST', rootUrl, JSON.stringify(payload));

export const updateTag = async ({ tagKey, payload }) =>
  await ajax('PUT', `${rootUrl}/${tagKey}`, JSON.stringify(payload));

export const deleteTag = async ({ tagKey }) => await ajax('DELETE', `${rootUrl}/${tagKey}`);

export const addTagToQuestion = async (payload) =>
  await ajax('POST', `${rootUrl}/tag-question`, JSON.stringify(payload));

export const removeTagFromQuestion = async (payload) =>
  await ajax('DELETE', `${rootUrl}/tag-question`, JSON.stringify(payload));
